import { render, staticRenderFns } from "./pieEcharts.vue?vue&type=template&id=0acfa166&scoped=true&"
import script from "./pieEcharts.vue?vue&type=script&lang=js&"
export * from "./pieEcharts.vue?vue&type=script&lang=js&"
import style0 from "./pieEcharts.vue?vue&type=style&index=0&id=0acfa166&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfa166",
  null
  
)

export default component.exports